<template>
  <footer class="app-footer app-footertools" :class="isDark ? 'bg-dark text-light' : ''">
    <div class="container-fluid d-flex align-items-center">
      <slot />
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooterTools',
  computed: { 
    isDark() {
      return this.$store.getters['tema/IS_DARK'] 
    }
   }
}
</script>

<style>
.app-footertools .container-fluid { display:flex; align-items:center; }
.app-footertools .container-fluid > * { flex:1 1 auto; min-width:0; }
</style>



// WEBPACK FOOTER //
// src/components/AppFooterTools.vue